import {$, moment, model} from './ext-refs';

function checkAppContext() {
    const checkParam = (p, msg) => {
        if (!p) {
            throw new Error(msg);
        }
    };
    // Validate that global variables had been injected from Outside of the React application.
    checkParam($, 'jQuery not in the HTML page');
    checkParam(moment, 'moment.js not in the HTML page');
    checkParam(model, 'model not in the HTML page');
    checkParam(model.paymentConfig, 'model missing paymentConfig');
}

export default checkAppContext;